import { render, staticRenderFns } from "./goodsCard.vue?vue&type=template&id=04c56118&scoped=true"
import script from "./goodsCard.vue?vue&type=script&lang=js"
export * from "./goodsCard.vue?vue&type=script&lang=js"
import style0 from "./goodsCard.vue?vue&type=style&index=0&id=04c56118&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c56118",
  null
  
)

export default component.exports